/**
 * Loading Overlay Component
 * 
 * Full-screen loading overlay with cancel button
 * Used during authentication flows
 */

import React from 'react';
import { IdeozLoading, Button } from '../index';
import { X } from 'lucide-react';

export interface LoadingOverlayProps {
  /** Whether the overlay is visible */
  isLoading: boolean;
  /** Callback when cancel button is clicked */
  onCancel: () => void;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isLoading, 
  onCancel 
}) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-200 bg-opacity-90">
      <div className="mb-3 flex flex-col items-center gap-4">
        <IdeozLoading size="lg" />
      </div>
      <Button
        onClick={onCancel}
        variant="primary"
        size="sm"
        className="absolute top-6 right-6"
      >
        <X size={16} strokeWidth={2} color="#667085" />
      </Button>
    </div>
  );
};

LoadingOverlay.displayName = 'LoadingOverlay';
